module.exports = __webpack_public_path__ + "static/media/akad_seguros_logo.69663eba.png";